module.exports = __webpack_public_path__ + "img/login.d1637099.png";